import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { selectWebp } from "../store/ui";

const getImagePaths = (basePath, category, extension) => {
  return category.map((imageName) => `${basePath}/${imageName}.${extension}`);
};

export default function useImagesSrc(isWebp) {
  const isSelectWebp = useSelector(selectWebp);
  const basePath = "../assets";
  const extension = isWebp || isSelectWebp ? "webp" : "png";

  const press = getImagePaths(
    `${basePath}/press`,
    ['c-net', 'the-new-york-times', 'the-verge'],
    'png'
  );

  const chooseTarget = getImagePaths(`${basePath}/track_target`, [
    "friend",
    "grandparent",
    "kid",
    "other",
    "partner",
    "sibling",
  ], "png");

  const chooseLocation = getImagePaths(`${basePath}/which_locations`, [
    "bar_restaurant",
    "friends",
    "hobby_classes",
    "home",
    "medical_institution",
    "other",
    "school",
    "unknown_locations",
    "work",
  ], "png");

  const chooseReason = getImagePaths(`${basePath}/primary_reason`, [
    "doubt",
    "keep_kid_away",
    "match_friend_location",
    "other",
    "prevent_lost",
    "safety_concerns",
    "stay_connected",
  ], "png");

  const chooseTime = getImagePaths(`${basePath}/how_often`, [
    "every_day",
    "every_hour",
    "never",
    "once_a_week",
    "rarely",
  ], "png");

  const chooseFrequency = getImagePaths(`${basePath}/how_frequently`, [
    "every_fifteen_minutes",
    "every_five_minutes",
    "every_hour",
    "other",
    "real_time",
  ], "png");

  const chooseLocationType = getImagePaths(`${basePath}/types_of_locations`, [
    "areas_high_crime",
    "bars_casinos",
    "distant_place_from_home",
    "easily_lost_locations",
    "ex_house",
    "friends_homes",
    "high_risk_injury",
    "hotels",
    "nightclubs",
    "other",
    "shopping_malls",
    "unknown_locations",
    "unsafe_parks_playgrounds",
    "unsupervised_public_areas",
  ], "png");

  const chooseQuantity = getImagePaths(`${basePath}/how_many`, [
    "one_two",
    "six_ten",
    "ten_plus",
    "three_five",
  ], "png");

  const chooseFeature = getImagePaths(`${basePath}/which_features`, [
    "all_the_above",
    "other",
    "place_alerts",
    "real_time_location_tracking",
    "sos_button",
  ], "png");

  const plansImages = getImagePaths(
    `${basePath}/plans`,
    [
      "app-icon",
      "reviewer1",
      "reviewer2",
      "reviewer3",
      "stars",
    ],
    "png"
  )

  const getInitImagesSources = () => {
    return {
      "choose-target": chooseTarget,
      "choose-location": chooseLocation,
      "choose-reason": chooseReason,
      "choose-time": chooseTime,
      "choose-frequency": chooseFrequency,
      "choose-location-type": chooseLocationType,
      "choose-quantity": chooseQuantity,
      "choose-feature": chooseFeature,
      "explore-solutions": `${basePath}/options/explore-solutions.${extension}`,
      "real-time-location": `${basePath}/options/real-time-location.${extension}`,
      "place-alerts": `${basePath}/options/place-alerts.${extension}`,
      "sos-alerts": `${basePath}/options/sos-alerts.${extension}`,
      "platform-support": `${basePath}/options/platform-support.${extension}`,
      "plans": plansImages,
      press: press,
      f1: `${basePath}/trivia/f1.png`,
      f2: `${basePath}/trivia/f2.png`,
      f3: `${basePath}/trivia/f3.png`,
      q21: chooseLocation,
      q22: chooseFrequency,
      "creating-profile": `${basePath}/trivia/stars.png`,
    };
  };

  const [imagesSources, setImagesSources] = useState(getInitImagesSources());

  useEffect(() => {
    const imagesSources = getInitImagesSources();
    setImagesSources(imagesSources);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return {
    imagesSources,
  };
}
